/**
 * Resets the application by redirecting to the home page
 * @returns void
 */
export default function resetApp(): void {
  window.location.href = `/`;
}
